export default __webpack_public_path__ + "static/root-app-icon-c704c226838d1c20c157a6e53b1f1943.png";